import { FunctionComponent } from 'react';
import { Label } from './Heading.styles';

export const Heading: FunctionComponent<{ children?: React.ReactNode }> = ({ children }) => {
  return (
    <Label variant="category" as="h2">
      {children}
    </Label>
  );
};
